if (!customElements.get('buy-button')) {
  class BuyButton extends HTMLElement {
    constructor() {
      super();

      this.handleClickRef = this.handleClick.bind(this);
      this.handleUpdateRef = this.handleUpdate.bind(this);
    }

    handleUpdate(event) {
      this.toggleAttribute('disabled', !event.detail.variant.available);
    }

    handleClick(event) {
      event.preventDefault();

      const form = this.closest('form');
      if (!form) return;

      const id = form.querySelector('[name="id"]')?.value;
      if (!id) return;

      const quantity = form.querySelector('[name="quantity"]')?.value || 1;

      // Buy it now = add the selected variant, then go straight to checkout.
      if (typeof Cart !== 'undefined' && Cart.add) {
        const body = new FormData();
        body.append('id', id);
        body.append('quantity', quantity);
        this.setAttribute('aria-busy', 'true');

        Cart.add(body)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.removeAttribute('aria-busy');
              return;
            }
            window.location.href = '/checkout';
          })
          .catch((error) => {
            console.error('[buy-button]', error);
            this.removeAttribute('aria-busy');
          });
        return;
      }

      // Fallback (no Cart helper): cart permalink from js-url.
      const url = this.getAttribute('js-url');
      if (!url) return;

      window.location.href = url
        .replace('[id]', id)
        .replace('[quantity]', quantity);
    }

    disconnectedCallback() {
      this.addEventListener('click', this.handleClickRef);

      document.removeEventListener('buy-button:update', this.handleUpdateRef);
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClickRef);

      document.addEventListener('buy-button:update', this.handleUpdateRef);
    }
  }

  customElements.define('buy-button', BuyButton);
}
